import { render } from "./CreatorProjects.vue?vue&type=template&id=489eb713"
import script from "./CreatorProjects.vue?vue&type=script&lang=js"
export * from "./CreatorProjects.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__